import { adminHttpClient } from '../commons/adminHttpClient'

export type SaveCoverageProviderRequest = {
  providerName: string
  providerStartDate: string
  familyMemberId?: string
}

export type SaveCoverageProviderResponse = {
  id: string
  providerName: string
  providerStartDate: string
  familyMemberId?: string
  startDate: string
}

const saveCoverageProvider = (values: SaveCoverageProviderRequest): Promise<SaveCoverageProviderResponse[]> => {
  return adminHttpClient.post('/Expenses/CoverageProvider', values)
}

export default saveCoverageProvider
